import React, { useContext, useState, useEffect } from 'react';
import AppContext from '../Context/AppContext';
import axios from 'axios';
import Card from '../layout/Card';
import { Network, ServerCogIcon } from "lucide-react"

const ServerStream = () => {
    const { mapUrl } = useContext(AppContext)
    const [streams, setStreams] = useState(null)
    const init = async () => {
        const response = await axios.get(mapUrl.stat_server_stream);
        if (response.data) {
            const format = Object.keys(response.data).map(k => ({ ...response.data[k] }))
            setStreams(format)
        }
    }
    useEffect(() => {
        init()
    }, [])
    console.log(streams);

    return (
        <div>
            {streams?.length > 0 && streams.map((stream, stream_i) => (
                <>
                    {Object.keys(stream).map(e => (
                        <div className='mb1' key={"stream_" + stream_i}>
                            <Card>
                                <p className='fb cw mb1'>{stream[e].key}</p>
                                <div className='df aic'>
                                    <div className='df aic mr1'>
                                        <Network size={20} color='#fff' />
                                        <p className='ml1 fr fs16 cw'>{stream[e]?.bandwidth}</p>
                                    </div>
                                    <div className='df aic mr1'>
                                        <ServerCogIcon size={20} color='#fff' />
                                        <p className='ml1 fr fs16 cw'>{stream[e]?.disk}</p>
                                    </div>

                                </div>
                            </Card>
                        </div>
                    ))}
                </>
            ))}
        </div>
    );
};

export default ServerStream;